module.exports = __webpack_public_path__ + "img/logo.dab48af2.png";